import { put, call } from "redux-saga/effects";
import { messageBoardConstants } from '../actions/constants/messageBoardConstants';
import MessageBoardService from "../services/api/messageBoardService";
import { exceptionHandler } from "../pages/common/functions";

function* messageBoardGetByFilter() {
	try {
		const result = yield call(MessageBoardService.messageBoardGetByFilter);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetByFilter_Success,
				payload: res.data
			});
		} else {
			yield put({ type: messageBoardConstants.MessageBoard_GetByFilter_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_GetByFilter_Failure, payload: e });
	}
}

 function* messageBoardSave(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_Save_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_Save_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_Save_Failure, payload: e });
	}
}

function* messageBoardDelete(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardDelete, request.input.id);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_Delete_Success,
				payload: res.data,
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_Delete_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_Delete_Failure, payload: e });
	}
}

function* messageBoardGetDetail(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetDetail, request.input.id);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetDetail_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetDetail_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_GetDetail_Failure, payload: e });
	}
}

function* messageBoardGetReport(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetReport, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetReport_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetReport_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_GetReport_Failure, payload: e });
	}
}

function* messageBoardGetTopicByFilter(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetTopicByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetTopic_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetTopic_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_GetTopic_Failure, payload: e });
	}
}

function* messageBoardTopicDelete(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardTopicDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_TopicDelete_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_TopicDelete_Failure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: messageBoardConstants.MessageBoard_TopicDelete_Failure, payload: error });
	}
}

function* messageBoardTopicRestore(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardTopicRestore, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_TopicRestore_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_TopicRestore_Failure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: messageBoardConstants.MessageBoard_TopicRestore_Failure, payload: error });
	}
}

 function* messageBoardGetPostByFilter(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetPostByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetPostByFilter_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetPostByFilter_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_GetPostByFilter_Failure, payload: e });
	}
}

function* messageBoardGetAlert(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetAlert, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetAlert_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetAlert_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_GetAlert_Failure, payload: e });
	}
}

 function* messageBoardPostDelete(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardPostDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_PostDelete_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_PostDelete_Failure, payload: res.data});
		}
	} catch (error) {
		yield put({ type: messageBoardConstants.MessageBoard_PostDelete_Failure, payload: error });
	}
}

function* messageBoardPostRestore(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardPostRestore, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_PostRestore_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_PostRestore_Failure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: messageBoardConstants.MessageBoard_PostRestore_Failure, payload: error });
	}
}

function* messageBoardPostFlag(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardPostFlag, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_PostFlag_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_PostFlag_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_PostFlag_Failure, payload: e });
	}
}

 function* messageBoardPostAuthorization(request: any) {
	try {
		const result = yield call(MessageBoardService.messageBoardPostAuthorization, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_PostAuthorization_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_PostAuthorization_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_PostAuthorization_Failure, payload: e });
	}
}

function* messageBoardGetReportType() {
	try {
		const result = yield call(MessageBoardService.messageBoardGetReportType);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetReportType_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetReportType_Failure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: messageBoardConstants.MessageBoard_GetReportType_Failure, payload: e });
	}
}

 function* messageBoardGetCountByYear(request) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetCountByYear, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetCountByYear_Success,
				payload: res.data.messageCountByMessageBoard
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetCountByYear_Failure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: messageBoardConstants.MessageBoard_GetCountByYear_Failure, payload: error });
	}
}

 function* messageBoardGetPublicMessageByUserId(request) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetByUserId, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetUserPublicMessage_Success,
				payload: res.data
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetUserPublicMessage_Failure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: messageBoardConstants.MessageBoard_GetUserPublicMessage_Failure, payload: error });
	}
}

 function* messageBoardGetChannelMessageByUserId(request) {
	try {
		const result = yield call(MessageBoardService.messageBoardGetChannelMessageByUserId, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: messageBoardConstants.MessageBoard_GetUserChannelMessage_Success,
				payload: result.data.dashboardMessages
			});
		}
		else {
			yield put({ type: messageBoardConstants.MessageBoard_GetUserChannelMessage_Failure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: messageBoardConstants.MessageBoard_GetUserChannelMessage_Failure, payload: error });
	}
}

export const messageBoardSaga = {
	messageBoardGetByFilter,
	messageBoardSave,
	messageBoardDelete,
	messageBoardGetDetail,
	messageBoardGetReport,
	messageBoardGetTopicByFilter,
	messageBoardTopicDelete,
	messageBoardTopicRestore,
	messageBoardGetPostByFilter,
	messageBoardGetAlert,
	messageBoardPostDelete,
	messageBoardPostRestore,
	messageBoardPostFlag,
	messageBoardPostAuthorization,
	messageBoardGetReportType,
	messageBoardGetCountByYear,
	messageBoardGetPublicMessageByUserId,
	messageBoardGetChannelMessageByUserId
}